var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WsCreate',{attrs:{"modelName":_vm.modelName,"label":_vm.label,"fields":_vm.fields,"primary":_vm.pageSetting.primary,"secondary":_vm.pageSetting.secondary,"customCreateAction":_vm.customCreateAction,"hasSequence":_vm.hasSequence}})}
var staticRenderFns = []

export { render, staticRenderFns }